<template>
  <div>
    <v-contextmenu ref="contextMenu">
      <!--<v-contextmenu-item @click="createTeam()">创建团队</v-contextmenu-item>
      <v-contextmenu-item
        v-show="isDeleteTeam && this.multipleSelection.length>0 && isGroupList"
        @click="deleteTeam()"
      >删除团队</v-contextmenu-item>
      <v-contextmenu-item v-show="multipleSelection.length>0 && isGroupList" @click="IMTeam()">团队聊天</v-contextmenu-item>
      <v-contextmenu-item
        v-show="multipleSelection.length>0 && isGroupList"
        @click="IMDetail()"
      >查看团队</v-contextmenu-item>-->
      <v-contextmenu-item @click="append(true)">新建分组</v-contextmenu-item>
      <v-contextmenu-item @click="Rename">重命名</v-contextmenu-item>
      <v-contextmenu-item @click="Delete">删除</v-contextmenu-item>
      <v-contextmenu-item
        v-show="contextMenu"
        v-if="contextMenu.NODETYPE!==2"
        @click="AllSubTaskView()"
      >查看子集完成情况</v-contextmenu-item>
      <v-contextmenu-item v-show="permissionType===2 && isGroupList" divider></v-contextmenu-item>
      <!--IsRoot && -->
      <v-contextmenu-item
        v-clipboard:copy="contextMenu.NODENAME"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError"
      >复制名称</v-contextmenu-item>
      <!--<v-contextmenu-item v-if="folderState != 0 && !isList && isFolder" @click="add()">添加</v-contextmenu-item>-->
      <!--<v-contextmenu-item
        v-show="multipleSelection.length>0 && !isList && !isGroupList"
        @click="Delete()"
      >移除</v-contextmenu-item>-->
      <v-contextmenu-item
        v-show="multipleSelection.length>0"
        v-if="contextMenu.NODETYPE!==2"
        @click="workRecordDetail()"
      >查看工作记录</v-contextmenu-item>
      <v-contextmenu-item
        v-show="multipleSelection.length>0"
        v-if="contextMenu.NODETYPE!==2"
        divider
      ></v-contextmenu-item>
      <v-contextmenu-item
        v-show="multipleSelection.length==1 && !isGroupList"
        v-if="contextMenu.NODETYPE!==2"
        @click="handleFolderMenuClick()"
      >详情</v-contextmenu-item>
      <v-contextmenu-item
        divider
        v-show="multipleSelection.length==1 && !isGroupList"
        v-if="contextMenu.NODETYPE!==2"
      ></v-contextmenu-item>
      <!--<v-contextmenu-item
        v-show="multipleSelection.length>0 && !isList && !isGroupList"
        @click="shear()"
      >剪切</v-contextmenu-item>
      <v-contextmenu-item
        v-show="multipleSelection.length>0 && !isList && !isGroupList"
        @click="copy()"
      >复制</v-contextmenu-item>-->
      <v-contextmenu-item v-if="contextMenu.NODETYPE!==2" @click="addWorkRecord">添加工作记录</v-contextmenu-item>
      <v-contextmenu-item v-if="contextMenu.NODETYPE!==2" @click="addTaskTag">设置标签</v-contextmenu-item>
      <v-contextmenu-item
        v-show="multipleSelection.length>0 && !isList && !isGroupList && !IsShowOnlyList"
        @click="move()"
      >移动到</v-contextmenu-item>
      <!--<v-contextmenu-item
        :disabled="!isPasteDisabled"
        v-if="!isList  && !isGroupList && isPasteDisabled"
        @click="paste()"
      >粘贴</v-contextmenu-item>-->
      <v-contextmenu-item
        divider
        v-show="multipleSelection.length>0"
        v-if="!isList &&!IsShowOnlyList"
      ></v-contextmenu-item>
    </v-contextmenu>
    <TeamInformationDialog ref="TeamInformationDialog"></TeamInformationDialog>
    <taskDialog ref="taskRelationDialog" @getValue="getTask"></taskDialog>
    <workRecordDialog ref="workRecordDialog"></workRecordDialog>
    <AllSubTreeNodeView ref="allSubNodeViewDialog"></AllSubTreeNodeView>
    <addTeam ref="addTeam"></addTeam>
    <iframe style="display:none;" :src="imSrc"></iframe>
    <el-dialog
      width="200"
      center
      :title="title+'分组'"
      :visible.sync="dialogRenameVisible"
      append-to-body
    >
      <el-form
        :model="formRename"
        :rules="rulesRename"
        ref="ruleFormRename"
        label-width="70px"
        size="small"
      >
        <el-form-item label="名称" prop="GroupName">
          <el-input v-model="formRename.GroupName"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveRename('ruleFormRename')">确 定</el-button>
        <el-button type="danger" @click="dialogRenameVisible=false">关 闭</el-button>
      </div>
    </el-dialog>
    <collectDialog
      :taskName="collectName"
      :Type="Type"
      :taskContextMenu="contextMenu"
      ref="collectDialog"
      @getNodeLoad="getNodeLoad"
    ></collectDialog>

    <TagSelect ref="tagSelect" :tagIds="tagIds" :showFootButton="true" @success="saveTag"></TagSelect>
    <SideTagsRecordDialog ref="SideTagsRecordDialog"></SideTagsRecordDialog>
  </div>
</template>

<script>
import { getTaskByTaskId } from "@/api/modules/basicData/task";
import workRecordDialog from "../taskGroup/workRecordDialog.vue";
import addTeam from "../team/addTeam.vue";
import AllSubTreeNodeView from "../taskGroup/AllSubTreeNodeView.vue";
import TeamInformationDialog from "../team/TeamInformationDialog.vue";
import collectDialog from "@/views/task/common/collectDialog.vue";
import folderApi from "@/api/modules/basicData/folder";
import { AddTaskViewHistory } from "@/api/modules/basicData/task";
import { UpdateTreePathName } from "@/api/modules/basicData/basicTask";
import { ConstTask } from "@/api/modules/basicData/task";
import { getToken } from "@/util/auth";
import { mapState, mapMutations } from "vuex";
import TagSelect from "./Tag/TagSelect.vue";
import { SaveTaskTags } from "@/api/modules/basicData/task";
const cookieUser = getToken();
export default {
  name: "contextmenuGroup",
  data() {
    return {
      userId: cookieUser.userId,
      imSrc: "",
      isGroupList: false,
      isDeleteTeam: false,
      isFolder: false,
      Type: 1, //0：设置收藏 1:文件夹 2：修改
      collectName: "新建分组",

      isDisable: false,
      title: "修改",
      dialogRenameVisible: false,
      formRename: {
        GroupName: "", //分组名称
      },
      rulesRename: {
        GroupName: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
    };
  },
  props: {
    multipleSelection: {
      //选中项
      type: Array,
      default: () => {
        return [];
      },
    },
    isShowOpenButton: {
      //是否显示打开按钮
      type: Boolean,
      default: true,
    },
    isShowButton: {
      //是否显示按钮
      type: Boolean,
      default: true,
    },
    isList: {
      //是否列表展示
      type: Boolean,
      default: false,
    },
    IsShowOnlyList: {
      type: Boolean,
      default: false,
    },
    contextMenu: {
      //选中当前行值
      type: Object,
      default: () => {},
      require: true,
    },
    folderState: {
      //0:常用 1：文件夹
      type: Number,
      default: 1,
    },
    permissionType: {
      //0:个人 1：共享 2：群聊
      type: Number,
      default: 2,
    },
  },
  watch: {
    contextMenu(row, oldRow) {
      if (row) {
        if (
          row.RELATIONTYPE === "PUB_GROUP" ||
          row.RELATIONTYPE === "E9354DE41375"
        )
          this.isFolder = true;
        else this.isFolder = false;

        if (row.RELATIONTYPE === "PUB_GROUP") this.isGroupList = true;
        else this.isGroupList = false;

        if (this.multipleSelection.length > 0) {
          let nodeList = this.multipleSelection.filter(
            (item) => item.CREATEUSERID == this.userId
          );
          if (nodeList.length > 0) {
            this.isDeleteTeam = true;
          } else {
            this.isDeleteTeam = false;
          }
        } else {
          this.isDeleteTeam = false;
        }
      } else {
        this.isGroupList = false;
        this.isDeleteTeam = false;
      }
    },
  },
  methods: {
    ...mapMutations({
      setCopy: "setCopy",
      setIsCopyOrPaste: "setIsCopyOrPaste",
      setEditTaskGroupList: "setEditTaskGroupList",
    }),
    onCopy(e) {
      this.$message.success("复制成功！");
    },
    onError(e) {
      this.$message.error("复制失败！");
    },
    Hide() {
      this.$refs.contextMenu.hide();
    },
    handleFolderMenuClick() {
      this.openBlank(this.contextMenu.RELATIONID);
    },
    openBlank(taskid) {
      // window.open(routeUrl.href, "_blank");
      let pars = {
        TaskId: taskid,
        Person: this.Person,
      };
      AddTaskViewHistory(pars).then((pmevent) => {});
      let hostUrl = location.href.split("#")[0];
      if (typeof jsObj == "undefined") {
        let routeUrl = this.$router.resolve({
          path: "/task-detailspage",
          query: {
            taskid: taskid,
          },
        });
        window.open(routeUrl.href);
      } else {
        let routeUrl = this.$router.resolve({
          path: "/task-detailspage",
          query: {
            taskid: taskid,
            code: this.code,
          },
        });
        jsObj.Invoke("OpenWebBrowser", hostUrl + routeUrl.href);
      }
    },
    open() {
      this.dbclick(this.contextMenu);
    },
    dbclick(row) {
      //双击行事件
      if (row.NODETYPE == 3 || row.NODETYPE == 4) {
        // setTimeout(()=>{
        //     this.$store.commit("changeCurTask", {});
        // },500)
        this.$store.dispatch("GetTaskTreePathList", {
          NodeId: row.NODETYPE == "4" ? row.LINKNODEID : row.NODEID,
          IsRoot: false,
        });
        this.$store.commit("setFolderPath", this.contextMenu);
      } else if (row.NODETYPE == 1) {
        // setTimeout(()=>{
        //     this.$store.commit("changeCurTask", {});
        // },500)
        this.$store.dispatch("GetTaskByChatGroupId", row.RELATIONID);
        this.$store.commit("setFolderPath", row);
      } else {
        this.openBlank(row.RELATIONID);
      }
    },
    Show(postition) {
      //显示右键菜单
      this.$refs.contextMenu.show(postition);
    },
    createTeam() {
      this.$refs.addTeam.OpenDialog();
    },
    deleteTeam() {
      this.$confirm("是否解散该团队?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 解散
          this.$store.dispatch("removeCluster", this.contextMenu.RELATIONID);
        })
        .catch((err) => {
          console.error(err);
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    IMTeam() {
      let url = `RedCoral://IM/?usercode=${cookieUser.account}&users=${this.contextMenu.RELATIONID}&chatType=1`;
      window.protocolCheck(url, () => {
        this.$message.warning("协议未注册");
      });
      this.imSrc = url;
    },
    IMDetail() {
      this.$refs.TeamInformationDialog.OpenDialog(this.contextMenu);
    },
    AllSubTaskView() {
      folderApi.GetAllSubTreePathTask(this.contextMenu.NODEID).then((data) => {
        if (data) this.$refs.allSubNodeViewDialog.OpenDialog(data);
      });
    },
    paste() {
      //粘贴
      console.log("multipleSelection", this.copyList);
      let pasteList = this.copyList;
      console.log("pasteList", JSON.stringify(pasteList));
      if (this.isCopyOrPaste == 0) {
        pasteList.forEach((item) => {
          item.PNODEID = this.contextMenu.NODEID;
          item.PNODENAME = this.contextMenu.NODENAME;
          // item.PNODETYPE = this.parentInfo.NODETYPE;
          item.PNODETYPE = this.contextMenu.NODETYPE;
          item.CREATETIME = new Date(item.CREATETIME);

          (item.PRELATIONID = this.contextMenu.RELATIONID),
            (item.PRELATIONTYPE = this.contextMenu.RELATIONTYPE),
            (item.RELATIONCREATETIME = new Date(item.RELATIONCREATETIME));
        });

        this.$store.dispatch("AddTaskTreePath", pasteList);
      } else {
        //剪切处理
        pasteList.forEach((item) => {
          item.PNODEID = this.contextMenu.NODEID;
          item.PNODENAME = this.contextMenu.NODENAME;
          item.PNODETYPE = this.contextMenu.NODETYPE;
          item.CREATETIME = new Date(item.CREATETIME);

          (item.PRELATIONID = this.contextMenu.RELATIONID),
            (item.PRELATIONTYPE = this.contextMenu.RELATIONTYPE),
            (item.RELATIONCREATETIME = new Date(item.RELATIONCREATETIME));
        });
        this.$store.dispatch("UpdateTaskTreePath", pasteList);
      }
    },
    saveRename(formName) {
      this.isDisable = true;

      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.title == "添加") {
            let folderList = [];
            let info = this.contextMenu;
            folderList.push({
              NODEID: 0,
              NODETYPE: 2,
              PermissionType: 0,
              UserId: this.userId,
              NODENAME: this.formRename.GroupName, //分组名称,
              CREATETIME: new Date(),
              PNODEID: info.NODEID,
              PNODENAME: info.NODENAME,
              PNODETYPE: info.NODETYPE,
              PRELATIONID: info.RELATIONID,
              PRELATIONTYPE: info.RELATIONTYPE,
              CREATEUSERID: this.userId,
              CREATEUSERNAME: this.userName,
              CHILDRENCOUNT: 0,
            });
            folderApi.AddTaskTreePath(folderList).then((res) => {
              if (res.ResultCode == 1) {
                this.$emit("getNodeLoad", this.contextMenu);
                this.dialogRenameVisible = false;
              } else {
                this.$message.error("添加失败!");
              }
            });
          } else {
            let obj = {
              Name: this.formRename.GroupName,
              RelationId: this.contextMenu.RELATIONID,
              NodeType: this.contextMenu.NODETYPE,
            };
            UpdateTreePathName(obj).then((res) => {
              if (res.ResultCode > 0) {
                this.$emit("getNodeLoad", this.contextMenu);
                this.dialogRenameVisible = false;
              } else {
                this.$message.error("错误,请重试！");
              }
            });
          }
        } else {
          this.isDisable = false;
          return false;
        }
      });
    },
    Rename() {
      //重命名
      this.dialogRenameVisible = true;
      this.formRename.GroupName = this.contextMenu.NODENAME;
      // let data = this.contextMenu;
      // data.isAdd = false;
    },
    getNodeLoad(row) {
      this.$emit("getNodeLoad", this.contextMenu);
    },
    Delete() {
      //删除
      this.$confirm("确认删除？")
        .then((_) => {
          folderApi
            .DelTaskTreePath(this.multipleSelection, this.Person)
            .then((res) => {
              if (res.ResultCode == 1) {
                // this.this.dialogRenameVisible=false;
                this.$emit("getNodeLoad", this.contextMenu);
                // this.$refs.collectTree.remove(this.contextMenu)
              } else {
                this.$message.error("删除失败!");
              }
            });
        })
        .catch((_) => {});
    },
    append(isContextmenu) {
      // let data = this.currentNode;
      //   this.title='添加'
      //   this.formRename.GroupName='新建分组'
      // this.dialogRenameVisible=true;
      this.Type = 1;
      this.collectName = "新建分组";
      this.$refs.collectDialog.openDialog(this.contextMenu);
    },
    moveOut() {
      //移除
      this.$store.dispatch("DelTaskTreePath", this.multipleSelection);
    },
    commonlyUsed() {
      // if (this.folderState == 0 || this.contextMenu.Isfrequent) {
      //   this.$store.dispatch("DelFrequentTreePath", [this.contextMenu]);
      // } else {
      //   this.$store.dispatch("AddFrequentTreePath", [this.contextMenu]);
      // }

      ConstTask(
        this.contextMenu.Isfrequent,
        this.userId,
        this.contextMenu.RELATIONID
      ).then((result) => {
        if (result.ResultCode > 0) {
          this.$message.info(
            this.contextMenu.Isfrequent ? "取消收藏成功" : "设置收藏成功"
          );
          this.contextMenu.Isfrequent = !this.contextMenu.Isfrequent;
        } else {
          this.$message.error(result.MsgInfo);
        }
      });
    },
    add() {
      this.MaxForm();
      if (typeof jsObj == "undefined") {
        this.$refs.taskRelationDialog.dialogVisible = true;
      } else {
        setTimeout(() => {
          this.$refs.taskRelationDialog.dialogVisible = true;
        }, 1000);
      }
    },
    rename() {
      //重命名
      console.log("contextMenu", this.contextMenu);
      // this.setEditTaskGroupList(this.contextMenu.index)
      this.taskGroupList[this.contextMenu.index].isEdit = true;
      this.oldRow = {
        ...this.contextMenu,
      };
      this.newRow = this.contextMenu;
    },
    move() {
      this.Type = 2;
      this.collectName = this.contextMenu.NODENAME;
      this.$refs.collectDialog.openDialog();
    },
    workRecordDetail() {
      console.log("multipleSelection", this.multipleSelection);
      folderApi
        .GetAllSubTreePathTaskIds(this.multipleSelection[0].NODEID)
        .then((res) => {
          this.MaxForm();
          this.$refs.workRecordDialog.OpenDialog(res);
        });
    },
    shear() {
      //剪切
      this.setIsCopyOrPaste(1);
      this.setCopy(this.multipleSelection);
    },
    save() {
      //保存模板
    },
    copy() {
      //复制
      this.setIsCopyOrPaste(0);
      this.setCopy(this.multipleSelection);
    },
    getTask(arr) {
      let folderList = [];
      let dt = new Date();
      arr.forEach((item) => {
        // let taskGroupInfo = this.taskGroupList.filter(
        //   p => p.RELATIONID == item.ID
        // );
        // if (taskGroupInfo.length == 0) {
        folderList.push({
          NODEID: 0,
          NODETYPE: item.TASKTYPE == "E9354DE41375" ? 3 : 0,
          NODENAME: item.TASKNAME,
          CREATETIME: dt,
          PNODEID: this.contextMenu.NODEID,
          PNODENAME: this.contextMenu.NODENAME,
          PNODETYPE: this.contextMenu.NODETYPE,
          PRELATIONID: this.contextMenu.RELATIONID,
          PRELATIONTYPE: this.contextMenu.RELATIONTYPE,
          RELATIONID: item.ID,
          RELATIONCREATETIME: new Date(item.CREATETIME),
          RELATIONTYPE: item.TASKTYPE,
          RELATIONTYPENAME: item.TASKTYPENAME,
          CREATEUSERID: this.userId,
          CREATEUSERNAME: this.userName,
          CHILDRENCOUNT: 0,
        });
        // }
      });

      if (folderList.length > 0) {
        if (this.IsShowOnlyList) {
          //&& this.IsRoot
          //im群聊
          this.$store.dispatch("InsertTaskIntoFolder", {
            folderList: folderList,
            folderId: this.groupId,
          });
        } else {
          if (this.contextMenu.RELATIONTYPE == "PUB_GROUP") {
            this.$store.commit("setGroupId", this.contextMenu.RELATIONID);
          }
          setTimeout(() => {
            this.$store.dispatch("AddTaskTreePath", folderList);
          }, 500);
        }
      }
    },
    addTaskTag() {
      if (!this.contextMenu) {
        this.$message.warning("请选中一行");
        return;
      }
      console.log("contextMenu", this.contextMenu);
      this.$refs.tagSelect.dialogVisible = true;
    },
    saveTag(values) {
      console.log(values);
      console.log(this.contextMenu);
      var tags = values.map((value) => {
        return {
          TASKID: this.contextMenu.RELATIONID,
          TAGID: value.ID,
          COLOR: value.COLOR,
          TAGNAME: value.TAGNAME,
          CREATEUSERID: value.CREATEUSERID,
          CREATEUSERNAME: value.CREATEUSERNAME,
          CREATEDEPTID: value.CREATEDEPTID,
          CREATEDEPTNAME: value.CREATEDEPTNAME,
          CREATECOMPANYID: value.CREATECOMPANYID,
          CREATECOMPANYNAME: value.CREATECOMPANYNAME,
        };
      });
      console.log(tags);
      SaveTaskTags(tags, this.contextMenu.RELATIONID).then((result) => {
        if (result.ResultCode > 0) {
          this.$store.dispatch("changeTaskSource");
        } else {
          this.$message.error(result.MsgInfo);
        }
      });
    },
    getTaskByTaskId() {
      getTaskByTaskId(this.contextMenu.RELATIONID, this.userId).then((res) => {
        this.$refs.SideTagsRecordDialog.dialogFormVisible = true;
        this.$refs.SideTagsRecordDialog.addRecordRelation(
          this.contextMenu.RELATIONID,
          res.TASKNAME,
          0,
          resizeBy.INSTANCE
        );
      });
    },

    addWorkRecord(obj) {
      this.getTaskByTaskId();
    },
  },

  components: {
    taskDialog: () =>
      import("@/components/basicTemplate/common/taskDialog.vue"),
    workRecordDialog,
    AllSubTreeNodeView,
    addTeam,
    TeamInformationDialog,
    collectDialog,
    TagSelect,
  },
  computed: {
    ...mapState({
      isCheckbox: (state) => state.task.isCheckbox,
      userId: (state) => state.task.userId,
      userName: (state) => state.task.realName,
      pathNameArr: (state) => state.folder.pathNameArr,
      pathName: (state) => state.folder.pathName,
      OrderIndex: (state) => state.folder.OrderIndex,
      OrderBy: (state) => state.folder.OrderBy,
      ViewType: (state) => state.folder.ViewType,
      curTask: (state) => state.task.curTask,
      Person: (state) => state.folder.Person,
      taskGroupList: (state) => state.task.taskGroupList,
      isPasteDisabled: (state) => state.folder.isPasteDisabled,
      startShiftInfo: (state) => state.folder.startShiftInfo,
      isCopyOrPaste: (state) => state.folder.isCopyOrPaste,
      parentInfo: (state) => state.folder.parentInfo,
      copyList: (state) => state.folder.copyList,
    }),
    tagIds() {
      return this.contextMenu.TagList != undefined &&
        this.contextMenu.TagList != null
        ? this.contextMenu.TagList.map((o) => o.TAGID)
        : [];
    },
  },
};
</script>

<style scoped>
</style>
